app.service('PlaceService', function ($http, ApiService, $rootScope) {


    //get empty place
    //Update  
    this.GetEmptyPlace = function (lang, mcdParam, zoneid) {
        var request = ApiService.post("/api/Place/GetEmptyPlace?lang=" + lang + '&mcd=' + mcdParam+"&zoneid=" + zoneid);
        return request;
    }

    //Create new
    this.AddPlace = function (Place) {
        $rootScope.ShowIconLoading();
        var request = $http({
            method: "AddPlace",
            url: "/api/PlaceAPI",
            data: Place
        })
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }
    //Get Single 
    this.getPlace = function (id, lang, lang2, index, sortKey, reverse) {
        return ApiService.get("/api/Place/GetPlace?id=" + id + "&lang=" + lang + "&lang2=" + lang2 + "&index=" + index + "&sortKey=" + sortKey + "&reverse=" + reverse);
    }

    //Get All
    this.getPlaceList = function () {
        return ApiService.get("/api/Place/GetPlaces");
    }

    this.GetPlaceList = function (zoneId, mcd, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, sparams, sgparams, searchText, AdvancedSearch) {
        var request = ApiService.post("/api/Place/GetPlaceList?zoneId=" + zoneId + "&mcd=" + mcd + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&sparams=" + sparams + "&sgparams=" + sgparams + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }

    //Update  
    this.UpdatePlace = function (Id, Place) {
        $rootScope.ShowIconLoading();
        var request = $http({
            method: "UpdatePlace",
            url: "/api/TVShowsAPI/" + Id,
            data: TvShow
        })
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Delete  
    this.DeletePlace = function (Id) {
        $rootScope.ShowIconLoading();
        var request = $http({
            method: "DeletePlace",
            url: "/api/TVShowsAPI/" + Id
        })
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    //Update  
    this.UpdatePlace = function (Place) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/Place/UpdatePlace", Place)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.UpdateDescription = function (Place) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/Place/UpdateDescriptionTranslation", Place)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.UpdateDescriptionStatus = function (Place) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/Place/UpdateDescriptionTranslationStatus", Place)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Update Description 
    this.TranslateDescription = function (Place, lang, lang2, index) {
        $rootScope.ShowIconLoading();
        var request = ApiService.post("/api/Place/TranslateDescription?lang=" + lang + "&lang2=" + lang2 + "&index=" + index, Place)
        .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }

    //Create New Description and associate with Bio
    this.CreateNewDescriptionForBio = function (descForCreation) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(descForCreation);
        var request = ApiService.post("/api/DescriptionApi/CreateNewDescriptionForObject/", st)
            .then(
                function success(data) {
                    $rootScope.returnNewDesc = angular.copy(data.data);
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    }


    this.GetSearchUrlParam = function (zoneId, mcd, itemsPerPage, pagenumber, sortKey, reverse, lang, isTopBarActive, searchText, AdvancedSearch) {
        var request = ApiService.post("/api/Place/GetSearchUrlParam?zoneId=" + zoneId + "&mcd=" + mcd + "&itemsPerPage=" + itemsPerPage + "&pagenumber=" + pagenumber + "&sortKey=" + sortKey + "&reverse=" + reverse + "&lang=" + lang + "&itba=" + isTopBarActive + "&st=" + encodeURIComponent(searchText), AdvancedSearch);
        return request;
    }

    //GetPlacePreview    
    this.GetPlacePreview = function (id, lang) {
        var request = ApiService.get("/api/Place/GetPlacePreview?id=" + id + "&lang=" + lang);
        return request;
    }

});